import styled from "styled-components";

export const WalletLogsWrapper = styled.div`
  margin-top: -25px;
`;

export const WalletLogsBorder = styled.div`
  width: 100%;
  height: 8px;
  background: var(--Black-100, #f0f0f0);
`;
